import { render, staticRenderFns } from "./LawAuthorityForm.vue?vue&type=template&id=fb6a5d28&"
import script from "./LawAuthorityForm.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityForm.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityForm.vue?vue&type=style&index=0&id=fb6a5d28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports